<template>
	<div class="page" :style="{ paddingTop: headerHeight + 'px' }">
		<nio-header-nav
			:is-white="true"
			position="fixed"
			black-icon
			@back="backToLastPage"
			:height.sync="headerHeight"
		/>
		<nio-image class="error_img" :src="customImageLink" />
		<div class="error_text">{{ description }}</div>
		<nio-button text="刷新" class="btn" @click="clickPrimaryButton" round></nio-button>
	</div>
</template>

<script setup>
import { ref, computed } from 'vue'
import util from '@/util/util'
import nativeHybrid from '@/util/nativeHybrid'
import router from '@/routes/index'

import NioFailDefault from '@/assets/images/nio_fail_default.webp'
import NioEmptyWifi from '@/assets/images/nio_empty_wifi.webp'
import AlpsFailDefault from '@/assets/images/alps_fail_default.webp'
import AlpsEmptyWifi from '@/assets/images/alps_empty_wifi.webp'

const headerHeight = ref(0)
const typeInQuery = util.getQueryString('type')
const desc = util.getQueryString('desc')
const refreshUrl = util.getQueryString('url')

const type = computed(() => typeInQuery || '')
const description = computed(() => (desc ? decodeURIComponent(desc) : '网络异常，请稍后重试'))
const customImageLink = computed(() => {
	const brand = nativeHybrid.getAppType()
	if (brand === 'NIO') {
		return type.value === 'busy' ? NioFailDefault : NioEmptyWifi
	}
	return type.value === 'busy' ? AlpsFailDefault : AlpsEmptyWifi
})

const backToLastPage = () => {
	if (nativeHybrid.isInWebview()) {
		nativeHybrid.closeSyn()
	} else {
		router.go(-2)
	}
}

const clickPrimaryButton = () => {
	if ('onLine' in navigator && !navigator.onLine) {
		return nativeHybrid.showToast('网络异常，请检查网络连接')
	}
	if (refreshUrl) {
		router.replace(refreshUrl)
	} else {
		router.go(-1)
	}
}
</script>
<style lang="scss">
.page {
	width: 100%;
	min-height: 100vh;
	display: flex;
	flex-direction: column;
	align-items: center;
	background-color: #fff;
	.error_img {
		margin-top: 146px;
		height: 220px;
		width: 320px;
	}
	.error_text {
		font-size: 16px;
		line-height: 19px;
		font-weight: 420;
		color: #9b9da9;
		text-align: center;
	}
	.btn {
		width: 120px;
		margin-top: 30px;
		font-size: 16px;
		line-height: 19px;
		font-weight: 420;
		text-align: center;
		color: #00bebe;
	}
}
</style>
